require([
    "common/formUtils",
    "common/spinner",
    "common/slickSlider",
    "common/productSlides"
],
function (formUtils, spinner, slickSlider, productSlides) {

    const FEATURES_SELECTOR = ".product-features";
    const HOVERABLES_SELECTOR = FEATURES_SELECTOR + " .product-feature-hoverable";
    const MARKERS_SELECTOR = ".product-feature-marker";

    const MODAL_SELECTOR = "#product-features-modal";
    const MODAL_TITLE_SELECTOR = MODAL_SELECTOR + " .product-feature-modal-title";
    const MODAL_BODY_SELECTOR = MODAL_SELECTOR + " .product-feature-modal-body";
    const MODAL_SLIDER_SELECTOR = MODAL_BODY_SELECTOR + " .product-slides";
    const SPINNER_SELECTOR = MODAL_SELECTOR + " .spinner-wrapper";

    function init() {
        $(HOVERABLES_SELECTOR)
            .on("mouseenter", hoverIn)
            .on("mouseleave", hoverOut)
            .on("click", markerClicked);
        $(MODAL_SELECTOR).on("hidden.bs.modal", productSlides.pauseAllVideos);
    }


    function hoverIn(event) {
        let featureId = getFeatureId(event.target);
        if (featureId) {
            $(FEATURES_SELECTOR + " " + MARKERS_SELECTOR + "[data-feature-id='" + featureId + "']").each(function (index, element) {
                let activeClass = $(element).data("activeClass");
                $(element).addClass(activeClass);
            });
        }
    }

    function hoverOut(event) {
        removeActiveClassFromAllMarkers();
    }

    function removeActiveClassFromAllMarkers() {
        $(FEATURES_SELECTOR + " " + MARKERS_SELECTOR).each(function (index, element) {
            let activeClass = $(element).data("activeClass");
            $(element).removeClass(activeClass);
        });
    }

    function getFeatureId(element) {
        let featureId = $(element).data("featureId");
        if (!featureId) featureId = $(element).siblings(MARKERS_SELECTOR).data("featureId");
        if (!featureId) featureId = $(element).find(MARKERS_SELECTOR).data("featureId");
        return featureId;
    }

    function getFeatureTitle(featureId) {
        return $(HOVERABLES_SELECTOR + " " + MARKERS_SELECTOR + "[data-feature-id='" + featureId + "']").siblings(".product-feature-title").html();
    }

    function markerClicked(event) {
        let featureId = getFeatureId(event.target);
        let featureTitle = getFeatureTitle(featureId);
        showModal(featureId, featureTitle);
    }

    function showModal(featureId, featureTitle) {
        $(MODAL_TITLE_SELECTOR).empty().html(featureTitle);
        slickSlider.destroy(MODAL_SLIDER_SELECTOR)
        $(MODAL_BODY_SELECTOR).empty();
        spinner.show(SPINNER_SELECTOR);
        $(MODAL_SELECTOR).modal("show");
        fetchDataFromBackEnd(featureId);
    }

    function fetchDataFromBackEnd(featureId) {
        let postData = { SlideGroupId: featureId, SlidesName: "features" };
        formUtils.useToken(postData);
        $.ajax({
            type: "POST",
            url: "/customapi/Product/ProductSlides",
            dataType: "text",
            data: postData,
            success: function (data) {
                // fill the fetched HTML into DOM
                $(MODAL_BODY_SELECTOR).html(data);
                // initializing the slider has to be done with a slight delay, because slick cannot act immediately on the freshly generated DOM
                // (the first slide comes out mangled if we try to initialize the slider immediately)
                setTimeout(function () {
                    slickSlider.init(MODAL_SLIDER_SELECTOR);
                    $(MODAL_SLIDER_SELECTOR).on('afterChange', productSlides.pauseAllVideos);
                    spinner.hide(SPINNER_SELECTOR);
                    productSlides.init(MODAL_SLIDER_SELECTOR);
                }, 500);
            },
            error: function (jq, status, errorThrown) {
                spinner.hide(SPINNER_SELECTOR);
                $(MODAL_BODY_SELECTOR).text("We're very sorry, but there were problems with fetching the data. Please try again later or call customer service for help.");
                console.log("ERROR in fetching feature data. FeatureId= " + featureId + " Status=" + status + " " + jq.status + " Message=" + errorThrown + " " + jq.responseText);
            },
            complete: function () {
            }
        });
    }

    init();

});

define("ProductFeatures/productFeatures", function(){});

